'use client';

import { useQuery } from '@tanstack/react-query';

import { fetchMFAStatus } from '../api';

import { usePreMfaToken } from './usePreMfaToken';

import { RQ_MFA_STATUS } from '@/modules/ReactQuery/cacheKeys';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useMfaStatus(shouldFetchMfaStatus: boolean) {
  const [, user] = useCurrentUser();
  const { data } = usePreMfaToken();
  const { pre_mfa_token } = data?.data || {};

  return useQuery({
    queryKey: [RQ_MFA_STATUS],
    queryFn: () => fetchMFAStatus(pre_mfa_token!).then(({ data }) => data),
    enabled: !!pre_mfa_token && !!user?.id && shouldFetchMfaStatus,
  });
}
